import { render, staticRenderFns } from "./nav-bar-store.vue?vue&type=template&id=bb020aea&scoped=true"
import script from "./nav-bar-store.vue?vue&type=script&lang=js"
export * from "./nav-bar-store.vue?vue&type=script&lang=js"
import style0 from "./nav-bar-store.vue?vue&type=style&index=0&id=bb020aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb020aea",
  null
  
)

export default component.exports